// @ts-strict-ignore
import {
	afterNextRender,
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	inject,
	Injector,
	Input,
	OnChanges,
	OnInit,
	output,
	signal,
	SimpleChanges,
	ViewChild,
	viewChild,
	viewChildren,
} from "@angular/core";
import {
	CameraLayoutType,
	ControlPanel,
	ControlPanelLocation,
	DataPermissions,
	DeleteRecordingOrRecordingGroupBatchRequest,
	DeleteRecordingRequest,
	Event,
	EventState,
	EventType,
	ExternalStatus,
	ListData,
	Modules,
	ParticipantType,
	Permissions,
	ReasonForCannotDeleteRecording,
	RecordingArchiveViewMode,
	Scenario,
	ScenarioRecording,
	ScenarioRecordingArchiveExternView,
	ScenarioRecordingArchiveView,
	ScenarioRecordingGroup,
	SessionState,
	SyncStatus,
	Tag,
	TagType,
	TrainingRoom,
	TrainingSession,
	TrainingSessionScenarioRecordingArchiveExternViewVM,
	TrainingSessionScenarioRecordingArchiveViewVM,
	UHOpen,
	VMEvent,
	VMIsSelected,
} from "@models";
// TODO(SIMSOFT-11935): ANGULAR_ANIMATIONS_CLEANUP
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {
	DeviceViewService,
	LayoutVariants,
	NotificationService,
	SimConfigurationService,
	SimEventService,
	SimMaterialDialogService,
	SimRecordingsService,
	SimScenarioService,
	SimSynchronizationService,
	SimTaggingService,
	SimTrainingRoomService,
	SimTrainingSessionService,
	SimUserInterfaceServiceExtended,
	SimUtilityService,
	TrackByMethods,
	SimPermissionService,
} from "@services";
import Enumerable from "linq";
import dayjs from "dayjs";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {EVENT_FILTER_OPTIONS} from "../../../../modules/dialog/material-dialogs/event-dialogs/event-filter-dialog/event-filter-dialog.component";
import dayOfYear from "dayjs/plugin/dayOfYear";
import {MatTabGroup} from "@angular/material/tabs";
import {throttle} from "utils-decorators";
import {BulkAction} from "../basic-administration-table-page/administration-table-page.types";
import {Translations, TranslationToken} from "@translations";
import {debounceTime} from "rxjs/operators";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {EventEmitterService} from "@event-emitter";
import {Router} from "@angular/router";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatButton, MatFabButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {SegmentedButtonComponent} from "../../../ui/segmented-button/segmented-button.component";
import {ButtonSegmentComponent} from "../../../ui/segmented-button/button-segment/button-segment.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatBadge} from "@angular/material/badge";
import {MatFormField, MatInput, MatLabel, MatSuffix} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {ComponentLoadingContainerComponent} from "../component-loading-container/component-loading-container.component";
import {EventContainerComponent} from "../event-container/event-container.component";
import {DatePipe, NgTemplateOutlet} from "@angular/common";
import {MatSelect} from "@angular/material/select";
import {MatOption} from "@angular/material/autocomplete";
import {NgAsDirective} from "ng-as";
import {StopPropagationDirective} from "../../../pipes/stop-propagation.directive";
import {MatRipple} from "@angular/material/core";
import {SimButton} from "../../../ui/button/sim-button.component";
import {MatDivider} from "@angular/material/list";
import {AnimatedIconComponent} from "../../../ui/animated-icon/animated-icon.component";
import {HasPermissionDirective} from "../../../directives/perm-directives/has-permission.directive";
import {MinsecPipe} from "../../../../shared/shared-pipes/minsec.pipe";
import {SimTagsChipViewComponent} from "../sim-advanced-inputs/sim-tags-chip-view/sim-tags-chip-view.component";
import {LmsPublishControlComponent} from "@common/migration/shared-components/lms-publish-control/lms-publish-control.component";
import {HasDataPermissionDirective} from "@common/directives/perm-directives/has-data-permission.directive";
import {
	CalendarSortingComponent,
	CalendarSortOrder,
	CalendarSortValue,
} from "../event-calendar/calendar-sorting/calendar-sorting.component";
import {EventUtils} from "../event-calendar/utils/event.utils";
import {MatChipListbox, MatChipOption} from "@angular/material/chips";

dayjs.extend(dayOfYear);

enum SelectionStep {
	Event = 0,
	TrainingSession = 1,
	ScenarioRecordingGroup = 2,
	ScenarioRecording = 3,
}

export type EventTimeFilter = "all" | "day" | "week" | "month" | "year";

export interface EVENT_SORT_OPTIONS {
	alphabetical: "up" | "down" | "unset";
	date: "up" | "down" | "unset";
	scenario: "up" | "down" | "unset";
}

export interface EVENT_ACTION_BUTTONS {
	deleteEventBtn?: boolean;
	changeOwnerShipBtn?: boolean;
	lockEventBtn?: boolean;
	importExportEventBtn?: boolean;
	selectEventBtn?: boolean;
	editEventBtn?: boolean;
	copyEventButton?: boolean;
}

export const EVENT_ACTION_BUTTONS_ONLY_SELECT_BTN: EVENT_ACTION_BUTTONS = {
	deleteEventBtn: false,
	changeOwnerShipBtn: false,
	lockEventBtn: false,
	importExportEventBtn: false,
	selectEventBtn: true,
};

export interface IIsReadyForArchive {
	id: string;
	isReadyForArchive?: boolean;
	postProcessingProgress: number;
}

@UntilDestroy()
@Component({
	selector: "sim-event-selection",
	templateUrl: "./event-selection.component.html",
	styleUrls: ["./event-selection.component.scss"],
	providers: [EventEmitterService],
	animations: [zoomInOnEnterAnimation({duration: 175}), zoomOutOnLeaveAnimation({duration: 175})],
	imports: [
		MatCheckbox,
		MatIconButton,
		MatIcon,
		SegmentedButtonComponent,
		ButtonSegmentComponent,
		MatTooltip,
		MatBadge,
		MatFormField,
		MatLabel,
		MatInput,
		FormsModule,
		MatSuffix,
		ComponentLoadingContainerComponent,
		EventContainerComponent,
		NgTemplateOutlet,
		MatSelect,
		MatOption,
		MatButton,
		NgAsDirective,
		StopPropagationDirective,
		MatRipple,
		SimButton,
		MatDivider,
		AnimatedIconComponent,
		HasPermissionDirective,
		SimTagsChipViewComponent,
		DatePipe,
		TranslatePipe,
		MinsecPipe,
		LmsPublishControlComponent,
		HasDataPermissionDirective,
		CalendarSortingComponent,
		MatChipListbox,
		MatChipOption,
		MatFabButton,
	],
})
export class EventSelectionComponent implements OnInit, OnChanges {
	DataPermissions = DataPermissions;
	T = Translations;
	hasLicenseModule = SimConfigurationService.hasLicenseModule;
	public defaultViewMode = SimConfigurationService.settings.recordingArchiveDefaultViewMode;
	RecordingArchiveViewMode = RecordingArchiveViewMode;
	getScenarioRecordingProgressText = SimUtilityService.getScenarioRecordingProgressText;

	Modules = Modules;
	SyncStatus = SyncStatus;
	LayoutVariants = LayoutVariants;

	SessionState = SessionState;
	CameraLayoutType = CameraLayoutType;
	TrackByMethods = TrackByMethods;
	ParticipantType = ParticipantType;

	public step: SelectionStep = SelectionStep.Event;

	public currentView: "left" | "right" = "left";
	public isViewToggleVisible = false;

	public enableSelection = false;
	public filterSearchFieldClosed = true;
	public searchValue = "";

	public events: (Event & UHOpen & VMEvent)[];
	public trainingSessions: TrainingSession[];
	public trainingRooms: TrainingRoom[];
	public hideTitle: boolean = true;

	@Input() syncRecordingsView = false;
	@Input() synchEndpointId: string = null;
	@Input() showOnlyRecordingPane = false;
	@Input() forceHideRecordingToggle = false;
	@Input() isArchive = true;
	@Input() showExports = false;
	@Input() showJoinStartActions = true;
	@Input() showSelectAllButton: boolean = false;
	@Input() includeEmptyTrainingSessions = true;
	@Input() selectEventString: string = "Select Event";
	@Input() eventSelectionOnly = false;
	@Input() isExamSchedule: boolean = false;
	onRecordingSelected = output<ScenarioRecording>();
	onEventSelected = output<Event & VMEvent>();
	onSessionSelected = output<TrainingSession>();
	selectionEnabled = output<boolean>();
	readonly #shouldRefreshData: EventEmitter<void> = new EventEmitter();
	readonly #refreshDataDebounceTime = 500;

	@Input() showOnlyRecordedScenarios = false;
	@Input() recordingSelectable = true;
	@Input() eventActions: EVENT_ACTION_BUTTONS = null;

	@Input() initialFilterOptions: EVENT_FILTER_OPTIONS;
	@Input() showAllEvents = false;

	@Input() showBackButton: boolean = false;
	onBackClicked = output<void>();

	@Input({required: true}) eventFetchingEndpoint!:
		"eventsForRecordingArchive" | "eventsForExamArchive" | "eventsForEventManager" | "eventsForExamSchedule";

	// Contains all scenario recordings of the selected event
	public eventScenarioRecordings: ScenarioRecording[] = [];
	public filteredScenarioRecordings: ScenarioRecording[];
	public trainingSessionArchiveViews: TrainingSessionScenarioRecordingArchiveViewVM[] = [];
	public trainingSessionArchiveViewsSync: TrainingSessionScenarioRecordingArchiveExternViewVM[] = [];

	public selectedEvent: Event = null;
	public selectedSession: TrainingSession;
	public selectedScenarioRecordingGroup: ScenarioRecordingGroup;
	public selectedRecording: ScenarioRecording;

	protected readonly currentSortValue = signal<CalendarSortValue>("dateTime");
	protected readonly currentSortOrder = signal<CalendarSortOrder>("desc");
	protected readonly selectedTimeFilter = signal<EventTimeFilter>("all");
	protected readonly timeFilterOptions: {value: EventTimeFilter; labelKey: string}[] = [
		{value: "all", labelKey: Translations.SHARED_EVENT_SELECTION_ALL},
		{value: "day", labelKey: Translations.SHARED_EVENT_SELECTION_DAY},
		{value: "week", labelKey: Translations.SHARED_EVENT_SELECTION_WEEK},
		{value: "month", labelKey: Translations.SHARED_EVENT_SELECTION_MONTH},
		{value: "year", labelKey: Translations.SHARED_EVENT_SELECTION_YEAR},
	];
	public eventFilterOptions: EVENT_FILTER_OPTIONS;
	public eventSortOptions: EVENT_SORT_OPTIONS = {
		alphabetical: "unset",
		date: "unset",
		scenario: "unset",
	};

	public panelsContainer: {
		panels: ControlPanel[];
		panelOptions: {
			activePanel: ControlPanel;
			activeUndockedPanel: ControlPanel;
		};
	};

	public readonly loadingEvents = signal<boolean>(false);
	public readonly loadingMoreEvents = signal<boolean>(false);
	public allEventsSelected: boolean;

	selectedBulkAction: BulkAction;
	bulkActions: BulkAction[] = [
		{
			value: "delete",
			displayNameTranslationKey: "delete",
			methodName: "bulkDelete",
		},
		{
			value: "export",
			displayNameTranslationKey: "export",
			methodName: "bulkExport",
		},
		{
			value: "sync",
			displayNameTranslationKey: "sync",
			methodName: "bulkSync",
		},
	];

	public currentPageForRecView: number = 0;
	public pageSizeForRecView: number = 50;
	public loadingTrainingSessionsWithScenarioRecordings: boolean = false;
	public trainingSessionsWithScenarioRecordingsLastPageReached: boolean = false;
	public eventsLastPageReached: boolean = false;
	public currentPageForEventView: number = 0;
	public pageSizeForEventView: number = 50;
	public loadingTrainingSessionsWithScenarioRecordingsSyncRec: boolean = false;
	public trainingSessionsWithScenarioRecordingsLastPageReachedSync: boolean = false;
	public currentPageForRecViewSync: number = 0;
	public pageSizeForRecViewSync: number = 50;
	public totalEventCount: number;
	public totalRecordingCount: number;

	protected permissionService = inject(SimPermissionService);
	readonly #injector = inject(Injector);

	protected readonly today = new Date();

	protected readonly eventRows = viewChildren<ElementRef<HTMLElement>>("eventRow");
	protected readonly eventsScrollContainer = viewChild<ElementRef<HTMLElement>>("eventsScrollContainer");
	#pendingTodayAnchorScroll = false;

	constructor(
		private simEventService: SimEventService,
		private simTrainingSessionService: SimTrainingSessionService,
		private simRecordingService: SimRecordingsService,
		private simSyncService: SimSynchronizationService,
		private simScenarioService: SimScenarioService,
		private simNotificationService: NotificationService,
		private simMaterialDialogService: SimMaterialDialogService,
		private simUserInterfaceService: SimUserInterfaceServiceExtended,
		private _eventEmitterService: EventEmitterService,
		protected translate: TranslateService,
		public deviceViewService: DeviceViewService,
		private simTrainingRoomService: SimTrainingRoomService,
		private _router: Router,
		private _simTaggingService: SimTaggingService,
	) {
		this.initializePanels();

		this._eventEmitterService.onEventsChanged.subscribe(() => {
			this.requestRefresh();
		});

		this.#shouldRefreshData.pipe(untilDestroyed(this), debounceTime(this.#refreshDataDebounceTime)).subscribe(async () => {
			await this.refreshData();
		});

		this._eventEmitterService.onScenarioRecordingIsReadyForArchive.subscribe((data) => {
			this.getRecs(data.scenarioRecordingId).forEach((rec) => {
				rec.isReadyForArchive = true;
			});
		});

		this._eventEmitterService.onScenarioRecordingChanged.subscribe(async (data) => {
			let updatedRec = await this.simRecordingService.getRecordingById(data.scenarioRecordingId);
			this.getRecs(data.scenarioRecordingId).forEach((rec) => {
				Object.assign(rec, updatedRec);
			});
		});

		this._eventEmitterService.onScenarioRecordingDownloadProgressChanged.subscribe((data) => {
			this.getRecs(data.scenarioRecordingId).forEach((rec) => {
				rec.postProcessingProgress = data.progress;
			});
		});

		this._eventEmitterService.onNotifyExport.subscribe(async (data) => {
			const rec = this.getRecs(data.scenarioRecordingId).firstOrDefault();
			if (rec) {
				let updatedRec = await this.simRecordingService.getRecordingById(rec.id);
				rec["finishedExportsCount"] = updatedRec?.finishedExportsCount;
			}
		});

		if (!SimConfigurationService.hasLicenseModule(Modules.Export)) {
			this.bulkActions = this.bulkActions.filter((action) => action.value !== "export");
		}
	}

	// Central entry point for shouldRefreshData.next() so unrelated refreshes always clear a stale pending anchor scroll.
	protected requestRefresh(options?: {anchorToToday: boolean}): void {
		this.#pendingTodayAnchorScroll = options?.anchorToToday ?? false;
		this.#shouldRefreshData.next();
	}

	private getRecs(scenarioRecordingId: string) {
		return Enumerable.from(<IIsReadyForArchive[]>this.eventScenarioRecordings ?? [])
			.concat(<IIsReadyForArchive[]>this.filteredScenarioRecordings ?? [])
			.concat(Enumerable.from(this.trainingSessionArchiveViews)?.selectMany((x) => x?.recordings) ?? [])
			.concat(Enumerable.from(this.trainingSessionArchiveViewsSync)?.selectMany((x) => x?.recordings) ?? [])
			.where((x) => x.id == scenarioRecordingId);
	}

	/*
	 * Fix so the inkbar from MatTabGroup
	 * is realigned after the view is checked
	 */
	@ViewChild(MatTabGroup) public dayTabs: MatTabGroup;

	@HostListener("window:resize")
	@throttle(200)
	onResize() {
		this.dayTabs?.realignInkBar();
	}

	async ngOnInit() {
		// set the view based on the license module
		// if the license is available, then the toggle will be rendered and `currentView` will be overwritten to the default view mode
		this.currentView = this.getInitialViewOrientation();
		this.isViewToggleVisible = !(
			this.forceHideRecordingToggle ||
			this.showOnlyRecordingPane ||
			!this.hasLicenseModule(Modules.EventDesigner)
		);

		if (!this.events?.length && !this.loadingEvents()) {
			this.requestRefresh({anchorToToday: this.currentView === "left"});
		}
		this.getTrainingRooms();

		this._simTaggingService.getAllTagsOfTagType(TagType.Recording).then((tags) => (this.allTags = tags));

		if (this.syncRecordingsView) {
			this._eventEmitterService.onSynchronizationJobInfoChanged.subscribe((args) => {
				if (args) {
					let scenarioRecordingIdToUpdate = args.synchronizationJobInfo?.scenarioRecordingId;
					let newSyncStatus: SyncStatus = SyncStatus.Running;

					if (!args.synchronizationJobInfo.finished) {
						if (!args.synchronizationJobInfo.startedAt) {
							newSyncStatus = SyncStatus.Queued;
						} else {
							newSyncStatus = SyncStatus.Running;
						}
					} else {
						if (args.synchronizationJobInfo.successful) {
							newSyncStatus = SyncStatus.Synced;
						} else {
							//error
							newSyncStatus = SyncStatus.Synced;
						}
					}

					if (this.trainingSessionArchiveViewsSync && this.trainingSessionArchiveViewsSync?.length > 0) {
						this.trainingSessionArchiveViewsSync.forEach((ts) => {
							ts.recordings.forEach((rec) => {
								if (rec.scenarioRecordingId === scenarioRecordingIdToUpdate) {
									rec.syncStatus = newSyncStatus;
								}
							});
						});
					}
				}
			});
		}
	}

	async ngOnChanges(changes: SimpleChanges) {
		let shouldRefresh = false;
		if (changes["initialFilterOptions"]) {
			this.eventFilterOptions = this.initialFilterOptions;
			shouldRefresh = true;
		}

		if (changes["synchEndpointId"]) {
			shouldRefresh = true;
		}

		if (shouldRefresh) {
			this.requestRefresh();
		}
	}

	protected getActiveFilterCount(): number {
		const filters = this.eventFilterOptions;
		if (!filters) return 0;

		const activeFilters: boolean[] = [
			!!filters.selectedOwnerId,
			!!filters.selectedScenarioId,
			filters.selectedParticipantIds?.length > 0,
			filters.selectedRoomIds?.length > 0,
			filters.selectedEventStatus?.length > 0,
			!!(filters.selectedDateRange?.start && filters.selectedDateRange?.end),
			!!filters.selectedShowFavoritesOnly,
		];

		return activeFilters.filter(Boolean).length;
	}

	private collectParameter(type: "events" | "recordings" | "recordingsSync") {
		const searchTerm = this.searchValue;
		const sortColumn = "Start";
		const sortAscending = false;
		const chipRange = this.#getTimeFilterRange();
		const from: Date | string = chipRange.from ?? this.eventFilterOptions?.selectedDateRange?.start;
		const to: Date | string = chipRange.to ?? this.eventFilterOptions?.selectedDateRange?.end;
		const ownerId: string = this.eventFilterOptions?.selectedOwnerId;
		const scenarioId: string = this.eventFilterOptions?.selectedScenarioId;
		const eventStates = this.eventFilterOptions?.selectedEventStatus ?? [];
		const participantUserIds = this.eventFilterOptions?.selectedParticipantIds ?? [];
		const trainingRoomIds = this.eventFilterOptions?.selectedRoomIds ?? [];
		const commaSeparatedParticipantUserIds: string = participantUserIds?.join(",");
		const commaSeparatedTrainingRoomIds: string = trainingRoomIds?.join(",");
		const commaSeparatedEventStates: string = this.eventFilterOptions?.selectedEventStatus?.join(",");
		const showFavoritesOnly = this.eventFilterOptions?.selectedShowFavoritesOnly ?? false;
		let page;
		let pageSize;

		switch (type) {
			case "events":
				pageSize = this.pageSizeForEventView;
				page = this.currentPageForEventView;
				break;
			case "recordings":
				pageSize = this.pageSizeForRecView;
				page = this.currentPageForRecView;
				break;
			case "recordingsSync":
				pageSize = this.pageSizeForRecViewSync;
				page = this.currentPageForRecViewSync;
				break;
		}

		return {
			searchTerm,
			sortColumn,
			sortAscending,
			from,
			to,
			ownerId,
			scenarioId,
			eventStates,
			participantUserIds,
			trainingRoomIds,
			commaSeparatedTrainingRoomIds,
			commaSeparatedParticipantUserIds,
			commaSeparatedEventStates,
			showFavoritesOnly,
			page,
			pageSize,
		};
	}

	private async getEvents() {
		this.currentPageForEventView === 0 ? this.loadingEvents.set(true) : this.loadingMoreEvents.set(true);

		try {
			const param = this.collectParameter("events");
			const result = await this.#fetchEventsByEndpoint(param);

			if (result) {
				this.#applyEventResult(result);
			}
			this.#sortEvents();
			this.getScenarioRecordingsForEvents();

			if (this.currentPageForEventView === 0 && this.#pendingTodayAnchorScroll && this.currentView === "left") {
				this.#pendingTodayAnchorScroll = false;
				this.scrollToTodayAnchor();
			}
		} finally {
			this.loadingEvents.set(false);
			this.loadingMoreEvents.set(false);
		}
	}

	async #fetchEventsByEndpoint(param: ReturnType<typeof this.collectParameter>): Promise<ListData<Event>> {
		switch (this.eventFetchingEndpoint) {
			case "eventsForEventManager":
			case "eventsForExamSchedule":
				return this.simEventService.listEvents({
					searchTermName: param.searchTerm,
					searchTermDescription: null,
					page: param.page,
					pageSize: param.pageSize,
					from: param.from,
					filterEventStates: this.eventFetchingEndpoint === "eventsForExamSchedule" ? [EventState.Planned] : param.eventStates,
					filterEventTypes: this.eventFetchingEndpoint === "eventsForExamSchedule" ? [EventType.Exam] : undefined,
					sortColumn: param.sortColumn,
					ownerId: param.ownerId,
					to: param.to,
					scenarioId: param.scenarioId,
					sortAscending: param.sortAscending,
					showFavoritesOnly: param.showFavoritesOnly,
				});
			case "eventsForRecordingArchive":
				return this.simEventService.listEventsForScenarioRecordingSelection(
					param.searchTerm,
					null,
					param.sortColumn,
					param.sortAscending,
					param.from,
					param.to,
					param.commaSeparatedEventStates,
					param.ownerId,
					param.scenarioId,
					param.commaSeparatedParticipantUserIds,
					param.commaSeparatedTrainingRoomIds,
					param.showFavoritesOnly,
					!this.showAllEvents,
					param.page,
					param.pageSize,
				);
			case "eventsForExamArchive":
				return this.simEventService.listEventsForExamArchive(
					param.searchTerm,
					null,
					param.sortColumn,
					param.sortAscending,
					param.from,
					param.to,
					param.commaSeparatedEventStates,
					param.ownerId,
					param.scenarioId,
					param.commaSeparatedParticipantUserIds,
					param.commaSeparatedTrainingRoomIds,
					param.showFavoritesOnly,
					param.page,
					param.pageSize,
				);
		}
	}

	#applyEventResult(result: ListData<Event>): void {
		this.totalEventCount = result.totalCount;
		if (this.currentPageForEventView === result.pages - 1) {
			this.eventsLastPageReached = true;
		}

		const resultMapped = <(Event & UHOpen & VMEvent)[]>(<unknown>result.data);
		for (const event of resultMapped) {
			const start = dayjs(event.start);
			const end = dayjs(event.end);
			event.isSingleDayEvent = start.year() === end.year() && start.dayOfYear() === end.dayOfYear();
		}

		this.events = this.events?.length ? this.events.concat(resultMapped) : resultMapped;
	}

	private async listScenarioRecordings(reload: boolean = false) {
		this.loadingTrainingSessionsWithScenarioRecordings = true;
		let param = this.collectParameter("recordings");

		if (reload) {
			this.trainingSessionArchiveViews = [];
		}
		let listData = await this.simRecordingService.listTrainingSessionsWithScenarioRecordings(
			param.from,
			param.to,
			param.searchTerm,
			param.ownerId,
			param.scenarioId,
			param.participantUserIds,
			param.trainingRoomIds,
			param.eventStates,
			param.showFavoritesOnly,
			!this.showAllEvents,
			param.sortColumn,
			param.sortAscending,
			param.page,
			param.pageSize,
		);
		if (listData.pages - 1 === param.page) {
			this.trainingSessionsWithScenarioRecordingsLastPageReached = true;
		}

		let result = <TrainingSessionScenarioRecordingArchiveViewVM[]>listData.data;

		this.totalRecordingCount = listData.totalCount;
		if (this.trainingSessionArchiveViews?.length === 0) {
			this.trainingSessionArchiveViews = result;
		} else {
			const overlap =
				result.length > 0
					? this.trainingSessionArchiveViews.find((ts) => ts.trainingSessionId === result[0].trainingSessionId)
					: null;

			if (overlap) {
				overlap.recordings = overlap.recordings.concat(result[0].recordings);
				this.trainingSessionArchiveViews = this.trainingSessionArchiveViews.concat(result.slice(1));
			} else {
				this.trainingSessionArchiveViews = this.trainingSessionArchiveViews.concat(result);
			}
		}

		this.#sortRecordingView();
		this.loadingTrainingSessionsWithScenarioRecordings = false;
	}

	private async listScenarioRecordingsForSyncRecordings(reload: boolean = false) {
		this.loadingTrainingSessionsWithScenarioRecordingsSyncRec = true;
		let param = this.collectParameter("recordings");

		if (reload) {
			this.trainingSessionArchiveViewsSync = [];
		}
		let listData = await this.simSyncService.listTrainingSessionsWithScenarioRecordings(
			this.synchEndpointId,
			param.from,
			param.to,
			param.searchTerm,
			param.ownerId,
			param.scenarioId,
			param.participantUserIds,
			param.trainingRoomIds,
			param.eventStates,
			param.sortColumn,
			param.sortAscending,
			param.page,
			param.pageSize,
		);

		if (listData.status == ExternalStatus.Ok) {
			if (listData.data.pages - 1 === param.page) {
				this.trainingSessionsWithScenarioRecordingsLastPageReachedSync = true;
			}

			let result = <TrainingSessionScenarioRecordingArchiveExternViewVM[]>listData.data.data;

			if (this.trainingSessionArchiveViewsSync?.length === 0) {
				this.trainingSessionArchiveViewsSync = result;
			} else {
				const overlap =
					result.length > 0
						? this.trainingSessionArchiveViewsSync.find((ts) => ts.trainingSessionId === result[0].trainingSessionId)
						: null;

				if (overlap) {
					overlap.recordings = overlap.recordings.concat(result[0].recordings);
					this.trainingSessionArchiveViewsSync = this.trainingSessionArchiveViewsSync.concat(result.slice(1));
				} else {
					this.trainingSessionArchiveViewsSync = this.trainingSessionArchiveViewsSync.concat(result);
				}
			}
		} else {
			this.trainingSessionArchiveViewsSync = [];
		}

		this.#sortRecordingView();
		this.loadingTrainingSessionsWithScenarioRecordingsSyncRec = false;
	}

	private async getScenarioRecordingsForEvents() {
		const eventIds = Enumerable.from(this.events)
			.select((event) => event.id)
			.toArray();

		this.eventScenarioRecordings = await this.simRecordingService.getScenarioRecordingsByEventIds(eventIds);
	}

	private initializePanels() {
		this.simUserInterfaceService.getPanels(ControlPanelLocation.EventSelection).then((result) => {
			this.panelsContainer = result;
		});
	}

	private getTrainingRooms() {
		this.simTrainingRoomService.getTrainingRooms().then((result) => {
			this.trainingRooms = result;
		});
	}

	public goToEventSelection() {
		this.step = SelectionStep.Event;

		this.selectedRecording = null;
		this.selectedScenarioRecordingGroup = null;
		this.selectedSession = null;

		this.onRecordingSelected.emit(null);
		this.onSessionSelected.emit(null);
	}

	public goToSessionSelection() {
		this.step = SelectionStep.TrainingSession;

		this.selectedSession = null;

		this.onRecordingSelected.emit(null);
	}

	public openFilterDialog() {
		this.simMaterialDialogService
			.openEventFilterDialog({
				selectedEventId: this.selectedEvent?.id,
				appliedFilter: this.eventFilterOptions,
			})
			.then((result) => {
				if (result?.action === "ok") {
					this.eventFilterOptions = result.appliedFilter;
					this.requestRefresh();
				}
			});
	}

	public back() {
		switch (this.step) {
			case SelectionStep.TrainingSession:
				this.step = SelectionStep.Event;
				this.selectedEvent = null;
				this.selectedSession = null;
				this.selectedScenarioRecordingGroup = null;
				this.selectedRecording = null;

				this.eventScenarioRecordings = [];

				break;
			case SelectionStep.ScenarioRecordingGroup:
				this.step = SelectionStep.TrainingSession;
				this.selectedSession = null;
				this.selectedScenarioRecordingGroup = null;
				this.selectedRecording = null;
				break;
			case SelectionStep.ScenarioRecording:
				if (this.selectedSession["isOsce"]) {
					this.step = SelectionStep.ScenarioRecordingGroup;
				} else {
					this.step = SelectionStep.TrainingSession;
				}
				this.selectedRecording = null;
				break;
		}
	}

	protected toggleEventSelected(event: Event & UHOpen & VMEvent) {
		this.events.find((e) => e.id === event.id).isSelected = !event.isSelected;
	}

	protected openEvent(event: Event & VMEvent) {
		// TODO: corpse removal
		// If Selection of events is enabled the normal event trigger
		// shouldn't be activated
		if (this.enableSelection) {
			return;
		}

		this.onEventSelected.emit(event);
		this.selectedEvent = event;

		if (!this.eventSelectionOnly) {
			this.step = SelectionStep.TrainingSession;

			if (this.selectedEvent) {
				this.simTrainingSessionService
					.searchTrainingSessions({
						trainingSessionIds: this.selectedEvent?.sessionIds,
						scenarioId: this.eventFilterOptions?.selectedScenarioId,
						userIds: this.eventFilterOptions?.selectedParticipantIds,
						trainingRoomIds: this.eventFilterOptions?.selectedRoomIds,
						includeEmptyTrainingSessions: this.includeEmptyTrainingSessions,
					})
					.then((result) => {
						this.trainingSessions = Enumerable.from(result)
							.where((trainingSession: TrainingSession) => !!trainingSession.scenarioRecordingGroups)
							.toArray() as TrainingSession[];

						// ----------------------------------------------------------------------- //
						// Hydrate scenarios                                                       //
						// ----------------------------------------------------------------------- //
						const scenarioIds = Enumerable.from(this.trainingSessions)
							.selectMany((trainingSession) => trainingSession.scenarioRecordingGroups)
							.selectMany((scenarioRecordingGroup) => scenarioRecordingGroup.scenarioRecordingsMap)
							.select((scenarioRecordingMapEntry) => scenarioRecordingMapEntry.scenarioId)
							.toArray();

						this.simScenarioService.getScenarioByIds(scenarioIds).then((result) => {
							const scenarios = result;

							for (const trainingSession of this.trainingSessions) {
								const trainingSessionScenarioIds = Enumerable.from(trainingSession.scenarioRecordingGroups)
									.selectMany((scenarioRecordingGroup) => scenarioRecordingGroup.scenarioRecordingsMap)
									.select((scenarioRecordingMapEntry) => scenarioRecordingMapEntry.scenarioId)
									.toArray();

								trainingSession["scenarioNames"] = Enumerable.from(scenarios)
									.where((scenario) => trainingSessionScenarioIds.indexOf(scenario.id) >= 0)
									.select((scenario) => scenario.name)
									.toArray()
									.join(", ");
							}
						});

						// ----------------------------------------------------------------------- //
						// Hydrate scenario recordings                                             //
						// ----------------------------------------------------------------------- //
						const scenarioRecordingIds = Enumerable.from(this.trainingSessions)
							.selectMany((trainingSession) => trainingSession.scenarioRecordingGroups)
							.selectMany((scenarioRecordingGroup) => scenarioRecordingGroup.scenarioRecordingsMap)
							.select((scenarioRecordingMapEntry) => scenarioRecordingMapEntry.scenarioRecordingId)
							.toArray();

						this.simRecordingService.getScenarioRecordingsByIds(scenarioRecordingIds).then((result) => {
							this.eventScenarioRecordings = result;

							for (const trainingSession of this.trainingSessions) {
								trainingSession["isOsce"] =
									Enumerable.from(trainingSession.scenarioRecordingGroups[0].scenarioRecordingsMap)
										.select((scenarioRecordingMapEntry) => scenarioRecordingMapEntry.scenarioRecordingId)
										.distinct()
										.count() > 1;

								// ----------------------------------------------------------------------- //
								// Hydrate location                                                        //
								// ----------------------------------------------------------------------- //
								const trainingRoomIds = Enumerable.from(this.eventScenarioRecordings)
									.selectMany((eventScenarioRecording) => eventScenarioRecording.recordingScenes)
									.select((recordingScene) => recordingScene.trainingRoomId)
									.toArray();

								trainingSession["locations"] = Enumerable.from(this.trainingRooms)
									.where((trainingRoom) => trainingRoomIds.indexOf(trainingRoom.id) >= 0)
									.select((trainingRoom) => trainingRoom.displayText)
									.distinct()
									.orderBy((trainingRoomName) => trainingRoomName)
									.toArray()
									.join(", ");

								// ----------------------------------------------------------------------- //
								// Hydrate scenario recordings for group                                   //
								// ----------------------------------------------------------------------- //
								for (const scenarioRecordingGroup of trainingSession.scenarioRecordingGroups) {
									const groupScenarioRecordingIds = Enumerable.from(scenarioRecordingGroup.scenarioRecordingsMap)
										.select((scenarioRecordingMapEntry) => scenarioRecordingMapEntry.scenarioRecordingId)
										.toArray();

									const groupScenarioRecordings = Enumerable.from(this.eventScenarioRecordings)
										.where((scenarioRecording) => groupScenarioRecordingIds.indexOf(scenarioRecording.id) >= 0)
										.toArray();

									scenarioRecordingGroup["scenarioRecordings"] = groupScenarioRecordings;
								}
							}
						});
					});
			}
		}
	}

	public selectRecordingById(scenarioRecordingId: string, $event?) {
		this.simRecordingService.getRecordingById(scenarioRecordingId).then((scenarioRecording) => {
			if (scenarioRecording && scenarioRecording.isReadyForArchive) {
				if (this.selectedRecording?.id !== scenarioRecording?.id) {
					this.selectedRecording = scenarioRecording;
				} else if (this.selectedRecording?.id === scenarioRecording?.id) {
					this.selectedRecording = null;
				}
				this.onRecordingSelected.emit(this.selectedRecording);
			}
		});
	}

	public async setCurrentView(newValue: "right" | "left") {
		if (newValue === "right") {
			this.hideTitle = true;
			if (this.trainingSessionArchiveViews?.length > 0) {
				this.deselectAllRecordings();
			}
		} else {
			newValue = "left";
			this.hideTitle = false;
			if (this.events?.length > 0) {
				this.deselectAllEvents();
			}
		}

		this.requestRefresh({anchorToToday: newValue === "left"});
		this.currentView = newValue;
	}

	private async refreshData() {
		this.events = null;
		this.trainingSessionArchiveViews = [];
		this.eventScenarioRecordings = [];
		this.eventsLastPageReached = false;

		this.currentPageForEventView = 0;
		this.currentPageForRecView = 0;

		if (this.currentView === "right") {
			this.loadingEvents.set(true);
			try {
				if (this.syncRecordingsView) {
					await this.listScenarioRecordingsForSyncRecordings(true);
				} else {
					await this.listScenarioRecordings(true);
				}
			} finally {
				this.loadingEvents.set(false);
			}
		} else {
			await this.getEvents();
		}
	}

	protected onTimeFilterChanged(value: EventTimeFilter): void {
		this.selectedTimeFilter.set(value);
		this.requestRefresh({anchorToToday: true});
	}

	#getTimeFilterRange(): {from: Date | null; to: Date | null} {
		const now = dayjs();
		switch (this.selectedTimeFilter()) {
			case "day":
				return {from: now.startOf("day").toDate(), to: now.endOf("day").toDate()};
			case "week":
				return {from: now.startOf("week").toDate(), to: now.endOf("week").toDate()};
			case "month":
				return {from: now.startOf("month").toDate(), to: now.endOf("month").toDate()};
			case "year":
				return {from: now.startOf("year").toDate(), to: now.endOf("year").toDate()};
			default:
				return {from: null, to: null};
		}
	}

	public onSortChanged(value: CalendarSortValue): void {
		this.currentSortValue.set(value);
		this.#sortEvents();
		this.#sortRecordingView();
	}

	public onSortOrderChanged(order: CalendarSortOrder): void {
		this.currentSortOrder.set(order);
		this.#sortEvents();
		this.#sortRecordingView();
		this.scrollToTodayAnchor();
	}

	#sortEvents(): void {
		if (!this.events) {
			return;
		}
		this.events = [...this.events].sort((a, b) => EventUtils.compareEvents(a, b, this.currentSortValue(), this.currentSortOrder()));
	}

	protected scrollToTodayAnchor(): void {
		if (this.currentView !== "left" || !this.events?.length || this.currentSortValue() !== "dateTime") {
			return;
		}
		const todayStart = dayjs().startOf("day").valueOf();
		const todayEnd = dayjs().endOf("day").valueOf();
		const anchorIndex =
			this.currentSortOrder() === "asc"
				? this.events.findIndex((e) => EventUtils.getEventTime(e) >= todayStart)
				: this.events.findIndex((e) => EventUtils.getEventTime(e) <= todayEnd);
		if (anchorIndex === -1) {
			return;
		}
		afterNextRender(
			() => {
				const container = this.eventsScrollContainer()?.nativeElement;
				const row = this.eventRows()[anchorIndex]?.nativeElement;
				if (!container || !row) {
					return;
				}
				// Adjust only this container's own scrollTop - scrollIntoView() would bubble up
				// and scroll every scrollable ancestor (e.g. a dashboard widget host), not just this list.
				container.scrollTop += row.getBoundingClientRect().top - container.getBoundingClientRect().top;
			},
			{injector: this.#injector},
		);
	}

	#sortRecordingView(): void {
		type SortableSession = {eventName: string; recordings: {start?: string | Date}[]};
		const direction = this.currentSortOrder() === "asc" ? 1 : -1;
		const comparator = (a: SortableSession, b: SortableSession): number => {
			if (this.currentSortValue() === "name") {
				return (a.eventName ?? "").localeCompare(b.eventName ?? "") * direction;
			}
			const timeA = a.recordings[0]?.start ? new Date(a.recordings[0].start).getTime() : 0;
			const timeB = b.recordings[0]?.start ? new Date(b.recordings[0].start).getTime() : 0;
			return (timeA - timeB) * direction;
		};

		if (this.trainingSessionArchiveViews?.length) {
			this.trainingSessionArchiveViews = [...this.trainingSessionArchiveViews].sort(comparator);
		}
		if (this.trainingSessionArchiveViewsSync?.length) {
			this.trainingSessionArchiveViewsSync = [...this.trainingSessionArchiveViewsSync].sort(comparator);
		}
	}

	setEventSortAlphabetical() {
		switch (this.eventSortOptions.alphabetical) {
			case "unset":
				this.eventSortOptions.alphabetical = "down";
				this.eventSortOptions.scenario = "unset";
				this.eventSortOptions.date = "unset";
				break;
			case "down":
				this.eventSortOptions.alphabetical = "up";
				this.eventSortOptions.scenario = "unset";
				this.eventSortOptions.date = "unset";
				break;
			case "up":
				this.eventSortOptions.alphabetical = "unset";
		}
	}

	setEventSortDate() {
		switch (this.eventSortOptions.date) {
			case "unset":
				this.eventSortOptions.date = "down";
				this.eventSortOptions.scenario = "unset";
				this.eventSortOptions.alphabetical = "unset";
				break;
			case "down":
				this.eventSortOptions.date = "up";
				this.eventSortOptions.scenario = "unset";
				this.eventSortOptions.alphabetical = "unset";
				break;
			case "up":
				this.eventSortOptions.date = "unset";
		}
	}

	setEventSortScenario() {
		switch (this.eventSortOptions.scenario) {
			case "unset":
				this.eventSortOptions.scenario = "down";
				this.eventSortOptions.alphabetical = "unset";
				this.eventSortOptions.date = "unset";
				break;
			case "down":
				this.eventSortOptions.scenario = "up";
				this.eventSortOptions.alphabetical = "unset";
				this.eventSortOptions.date = "unset";
				break;
			case "up":
				this.eventSortOptions.scenario = "unset";
		}
	}

	hasSortOptions() {
		return (
			this.eventSortOptions.date !== "unset" ||
			this.eventSortOptions.alphabetical !== "unset" ||
			this.eventSortOptions.scenario !== "unset"
		);
	}

	selectAllEvents() {
		this.allEventsSelected = !this.allEventsSelected;
		if (this.currentView === "left") {
			this.events.forEach((event) => (event.isSelected = this.allEventsSelected));
		} else if (!this.syncRecordingsView) {
			this.trainingSessionArchiveViews.forEach((trainingSession) => {
				trainingSession.recordings.every((recording) => (recording.isSelected = this.allEventsSelected));
			});
		} else {
			this.trainingSessionArchiveViewsSync.forEach((trainingSession) => {
				trainingSession.recordings.every((recording) => {
					if (recording.syncStatus === SyncStatus.Missing) {
						recording.isSelected = this.allEventsSelected;
					}
				});
			});
		}
	}

	isEventSelected() {
		if (this.events?.length > 0) {
			return this.events.some((event) => event.isSelected);
		} else {
			return false;
		}
	}

	isRecordingSelected() {
		if (this.trainingSessionArchiveViews?.length > 0) {
			return Enumerable.from(this.trainingSessionArchiveViews).any((trainingSession) =>
				trainingSession.recordings.some((rec) => rec.isSelected),
			);
		} else {
			return false;
		}
	}

	executeBulkAction() {
		switch (this.selectedBulkAction.value) {
			case "delete":
				this.simMaterialDialogService
					.openDeleteDialog({
						deleteTitle:
							this.currentView === "left"
								? this.translate.instant(this.T.EVENTS_DELETE_DIALOG_TITLE)
								: this.translate.instant(this.T.RECORDINGS_DELETE_DIALOG_TITLE),
						deleteText:
							this.currentView === "left"
								? this.translate.instant(this.T.EVENTS_DELETE_DIALOG_TEXT)
								: this.translate.instant(this.T.RECORDINGS_DELETE_DIALOG_TEXT, {recordingName: ""}),
						deleteButtonText: this.translate.instant(this.T.EVENTS_DELETE_DIALOG_OK),
						cancelText: this.translate.instant(this.T.EVENTS_DELETE_DIALOG_CANCEL),
					})
					.then((result) => {
						if (result?.action === "ok") {
							if (this.currentView === "left") {
								let eventIds = this.events.filter((event) => event.isSelected).map((event) => event.id);

								this.simEventService
									.deleteBatchEvents({eventIds: eventIds})
									.then(
										() => {},
										() => {
											this.simNotificationService.notifyError("Could not delete items");
										},
									)
									.finally(() => {
										this.requestRefresh();
										this.enableSelection = false;
										this.simNotificationService.notifySuccess();
									});
							} else {
								let recordingTobeDeleted: DeleteRecordingRequest[] = [];
								this.trainingSessionArchiveViews.forEach((trainingSession) => {
									recordingTobeDeleted.push(
										...trainingSession.recordings
											.filter((recording) => recording.isSelected)
											.map((recording) => {
												return {
													recordingId: recording.scenarioRecordingId,
												};
											}),
									);
								});

								let reqData: DeleteRecordingOrRecordingGroupBatchRequest = {
									deleteRecordingRequests: recordingTobeDeleted,
								};

								this.simRecordingService.deleteBatch(reqData).then(
									(response) => {
										if (response) {
											if (response.success) {
												this.simNotificationService.notifySuccess(
													this.translate.instant(this.T.SCENARIO_RECORDING_BATCH_DELETE_SUCCESS),
												);
											} else {
												let reasonTranslation = this.translate.instant(
													this.T.SCENARIO_RECORDING_BATCH_DELETE_FAILED_GENERAL,
												);

												let failedDeletionResponse = response.deleteRecordingResponses.find(
													(response) => !response.couldDelete,
												);

												let failedDeletionRecording: ScenarioRecordingArchiveView = null;

												this.trainingSessionArchiveViews.forEach((session) => {
													let match = session.recordings.find(
														(recording) => recording.id === failedDeletionResponse.recordingId,
													);
													if (match) {
														failedDeletionRecording = match;
													}
												});

												if (failedDeletionResponse && failedDeletionRecording) {
													switch (failedDeletionResponse.reason) {
														case ReasonForCannotDeleteRecording.ExportInProgress:
															reasonTranslation = this.translate.instant(
																this.T.SCENARIO_RECORDING_BATCH_DELETE_FAILED_EXPORT_IN_PROGRESS,
																{
																	recordingName: failedDeletionRecording.scenarioRecordingName,
																},
															);
													}
												}

												this.simMaterialDialogService
													.openInformationDialog({
														okText: this.translate.instant(this.T.BUTTON_OK),
														title: this.translate.instant(this.T.SCENARIO_RECORDING_DELETE_FAILED_TITLE),
														description: reasonTranslation,
													})
													.then();
											}
										} else {
											this.simNotificationService.notifyError(
												this.translate.instant(this.T.SCENARIO_RECORDING_BATCH_DELETE_FAILED_GENERAL),
											);
										}
										this.listScenarioRecordings(true);
									},
									(err) => {
										this.simNotificationService.notifyError(err);
									},
								);
							}
						}
					});
				break;
			case "sync":
				let scenarioRecordingIds: string[] = [];
				this.trainingSessionArchiveViewsSync.forEach((ts) => {
					scenarioRecordingIds = scenarioRecordingIds.concat(
						ts.recordings.filter((rec) => rec.isSelected).map((rec) => rec.scenarioRecordingId),
					);
				});

				this.simSyncService
					.addSynchronizationFromRecordings({
						synchEndpointId: this.synchEndpointId,
						scenarioRecordingIds: scenarioRecordingIds,
					})
					.then((res) => {
						if (res) {
							this.simNotificationService.notifySuccess();
							this.trainingSessionArchiveViewsSync.forEach((ts) => {
								ts.recordings.every((rec) => (rec.isSelected = false));
							});
							this.enableSelection = false;
						}
					});
				break;
			case "export":
				if (this.currentView === "right") {
					let scenarioRecordingIdList: string[] = [];
					this.trainingSessionArchiveViews.forEach((ts) => {
						scenarioRecordingIdList = scenarioRecordingIdList.concat(
							ts.recordings.filter((rec) => rec.isSelected).map((rec) => rec.scenarioRecordingId),
						);
					});
					this.openScenarioRecordingBulkExportDialog(scenarioRecordingIdList);
				} else {
					let eventIdList: string[] = [];
					this.events.forEach((event) => {
						if (event.isSelected) {
							eventIdList.push(event.id);
						}
					});
					this.simMaterialDialogService.openEventExportDialog({eventId: null, eventIdList: eventIdList});
				}
				break;
		}
	}

	enableSelectionClicked() {
		this.enableSelection = !this.enableSelection;
		if (!this.enableSelection) {
			this.allEventsSelected = false;
			this.deselectAllEvents();
			this.deselectAllRecordings();
		}
		if (!this.enableSelection) {
			this.events.forEach((event) => (event.isSelected = false));
		}
	}

	toggleFilterField() {
		this.filterSearchFieldClosed = !this.filterSearchFieldClosed;
		if (this.filterSearchFieldClosed) {
			if (this.searchValue !== "" && this.searchValue !== undefined) {
				this.searchValue = "";
				this.requestRefresh();
			}
		}
	}

	openScenarioInformationDialog(scenario: Scenario) {
		this.simMaterialDialogService.openScenarioInformationDialog({
			scenario: scenario,
		});
	}

	private deselectAllRecordings() {
		this.trainingSessionArchiveViews?.forEach((trainingSession) => {
			trainingSession.recordings.every((recording) => (recording.isSelected = false));
		});
		this.enableSelection = false;
		this.allEventsSelected = false;
	}

	private deselectAllEvents() {
		this.events?.every((event) => (event.isSelected = false));
		this.enableSelection = false;
		this.allEventsSelected = false;
	}

	deleteRecording(scenarioRecording: ScenarioRecordingArchiveView & VMIsSelected) {
		if (!this.permissionService.HasDataPerm(scenarioRecording, DataPermissions.Delete)) {
			return;
		}

		this.simMaterialDialogService
			.openDeleteDialog({
				deleteTitle: this.translate.instant(this.T.RECORDINGS_DELETE_DIALOG_TITLE),
				deleteText: this.translate.instant(this.T.RECORDINGS_DELETE_DIALOG_TEXT, {
					recordingName: scenarioRecording.scenarioRecordingName,
				}),
				deleteButtonText: this.translate.instant(this.T.RECORDINGS_DELETE_DIALOG_OK),
				cancelText: this.translate.instant(this.T.RECORDINGS_DELETE_DIALOG_CANCEL),
			})
			.then((output) => {
				if (output.action === "ok") {
					this.simRecordingService
						.deleteRecording({
							recordingId: scenarioRecording.id,
						})
						.then((response) => {
							if (response) {
								if (response.couldDelete) {
									this.simNotificationService.notifySuccess(
										this.translate.instant(this.T.SCENARIO_RECORDING_DELETE_SUCCESS),
									);

									this.listScenarioRecordings(true);
								} else {
									let reasonTranslationsKey: TranslationToken = this.T.SCENARIO_RECORDING_DELETE_FAILED_GENERAL;
									switch (response.reason) {
										case ReasonForCannotDeleteRecording.ExportInProgress:
											reasonTranslationsKey = this.T.SCENARIO_RECORDING_DELETE_FAILED_EXPORT_IN_PROGRESS;
									}
									this.simMaterialDialogService
										.openInformationDialog({
											okText: this.translate.instant(this.T.BUTTON_OK),
											title: this.translate.instant(this.T.SCENARIO_RECORDING_DELETE_FAILED_TITLE),
											description: this.translate.instant(reasonTranslationsKey),
										})
										.then();
								}
							} else {
								this.simNotificationService.notifyError(
									this.translate.instant(this.T.SCENARIO_RECORDING_DELETE_FAILED_GENERAL),
								);
							}
						});
				}
			});
	}

	toggleLockEvent(scenarioRecording: ScenarioRecordingArchiveView & VMIsSelected) {
		if (!this.permissionService.HasDataPerm(scenarioRecording, DataPermissions.Edit)) {
			return;
		}

		if (scenarioRecording.lockedForDeletion) {
			this.simMaterialDialogService
				.openConfirmationDialog({
					title: this.translate.instant(this.T.RECORDING_UNLOCK_DIALOG_TITLE),
					description: this.translate.instant(this.T.RECORDING_UNLOCK_DIALOG_DESCRIPTION),
					okText: this.translate.instant(this.T.RECORDING_UNLOCK_DIALOG_OK),
					cancelText: this.translate.instant(this.T.RECORDING_UNLOCK_DIALOG_CANCEL),
				})
				.then((response) => {
					if (response.action !== "ok") {
						return;
					}

					this.simRecordingService
						.setTrainingSessionLock({
							newLockState: false,
							trainingSessionId: scenarioRecording.trainingSessionId,
						})
						.then((response) => {
							if (response.success) {
								scenarioRecording.lockedForDeletion = false;
							}
						});
				});
		} else {
			this.simRecordingService
				.setTrainingSessionLock({
					newLockState: true,
					trainingSessionId: scenarioRecording.trainingSessionId,
				})
				.then((response) => {
					if (response.success) {
						scenarioRecording.lockedForDeletion = true;
					}
				});
		}
	}

	private getInitialViewOrientation(): "left" | "right" {
		if (this.forceHideRecordingToggle) {
			return "left";
		}

		if (this.showOnlyRecordingPane) {
			return "right";
		}

		if (!this.hasLicenseModule(Modules.EventDesigner)) {
			return "right";
		}

		return this.defaultViewMode === RecordingArchiveViewMode.Recordings ? "right" : "left";
	}

	openScenarioRecordingExportDialog(scenarioRecording: ScenarioRecordingArchiveView & VMIsSelected) {
		if (!this.permissionService.HasDataPerm(scenarioRecording, DataPermissions.Export)) {
			return;
		}

		this.simMaterialDialogService.openRecordingExportDialog({
			scenarioRecordingId: scenarioRecording.scenarioRecordingId,
			scenarioRecordingIdList: null,
		});
	}

	openScenarioRecordingBulkExportDialog(scenarioRecordingIdList: string[]) {
		const dialogRef = this.simMaterialDialogService.openRecordingExportDialog({
			scenarioRecordingId: null,
			scenarioRecordingIdList: scenarioRecordingIdList,
		});
	}

	openScenarioRecordingTTTDialog(scenarioRecording: ScenarioRecordingArchiveView & VMIsSelected) {
		this.simMaterialDialogService.openScenarioRecordingFileSetConversionDialog({
			scenarioRecordingId: scenarioRecording.scenarioRecordingId,
		});
	}

	listScrolled(e): void {
		const el = e.target;
		if (el.scrollHeight > el.scrollTop + el.offsetHeight) {
			return;
		}

		if (this.currentView === "left") {
			this.#loadNextEventPage();
		} else if (this.syncRecordingsView) {
			this.#loadNextSyncRecordingPage();
		} else {
			this.#loadNextRecordingPage();
		}
	}

	#loadNextEventPage(): void {
		if (!this.loadingEvents() && !this.eventsLastPageReached) {
			this.currentPageForEventView++;
			this.getEvents();
		}
	}

	#loadNextRecordingPage(): void {
		if (!this.loadingTrainingSessionsWithScenarioRecordings && !this.trainingSessionsWithScenarioRecordingsLastPageReached) {
			this.currentPageForRecView++;
			this.listScenarioRecordings();
		}
	}

	#loadNextSyncRecordingPage(): void {
		if (!this.loadingTrainingSessionsWithScenarioRecordingsSyncRec && !this.trainingSessionsWithScenarioRecordingsLastPageReachedSync) {
			this.currentPageForRecViewSync++;
			this.listScenarioRecordingsForSyncRecordings();
		}
	}

	syncRecording(scenarioRecording: (ScenarioRecordingArchiveView & VMIsSelected) | (ScenarioRecordingArchiveExternView & VMIsSelected)) {
		this.simSyncService
			.addSynchronizationFromRecordings({
				synchEndpointId: this.synchEndpointId,
				scenarioRecordingIds: [scenarioRecording.scenarioRecordingId],
			})
			.then((value) => {
				if (value) {
					//this.simNotificationService.notifySuccess( "Successfully started sync job");
				}
			});
	}

	isSyncRecordingSelected() {
		if (this.trainingSessionArchiveViewsSync?.length > 0) {
			return Enumerable.from(this.trainingSessionArchiveViewsSync).any((trainingSession) =>
				trainingSession.recordings.some((rec) => rec.isSelected),
			);
		} else {
			return false;
		}
	}

	isBulkActionVisible(bulkAction: BulkAction) {
		if (this.syncRecordingsView) {
			return !(bulkAction.value === "delete");
		}

		if (!this.syncRecordingsView) {
			return bulkAction.value !== "sync";
		}
	}

	openInArchive(scenarioRecording: ScenarioRecordingArchiveView) {
		this._router.navigate([`/web-manager/list/scenario-archive/player/0/${scenarioRecording.id}`]);
	}

	changeOwnership(scenarioRecording: ScenarioRecordingArchiveView & VMIsSelected) {
		if (!this.permissionService.HasDataPerm(scenarioRecording, DataPermissions.Edit)) {
			return;
		}

		this.simMaterialDialogService
			.openUpdateOwnershipDialog({
				type: "ScenarioRecording",
				id: scenarioRecording.id,
				currentOwnerId: scenarioRecording.ownerUserId,
			})
			.then((result) => {
				if (result?.refreshNeeded) {
					this.requestRefresh();
				}
			});
	}

	protected readonly Permissions = Permissions;
	protected readonly TagType = TagType;
	protected allTags: Tag[] = [];
	public readonly TrainingSessionCon: {
		trainingSession: TrainingSessionScenarioRecordingArchiveViewVM | TrainingSessionScenarioRecordingArchiveExternViewVM;
		isSyncView: boolean;
	};
	protected readonly Math = Math;
}
